import { render, staticRenderFns } from "./HotelProfile.vue?vue&type=template&id=ec4a1f3a&scoped=true"
import script from "./HotelProfile.vue?vue&type=script&lang=js"
export * from "./HotelProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4a1f3a",
  null
  
)

export default component.exports